// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDacapprovelogIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDacapprovelogIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDacapprovelogIconOutlined = function DrrpDacapprovelogIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDacapprovelogIconOutlinedSvg
  }));
};

DrrpDacapprovelogIconOutlined.displayName = 'DrrpDacapprovelogIconOutlined';
export default React.forwardRef(DrrpDacapprovelogIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDacapprovelogIconOutlined.js
// module id = 2499
// module chunks = 0